const loadMore = () => {
    (function recall( btn, blog ) {
        const nextBtn = document.querySelector( btn );

        nextBtn?.addEventListener( 'click', function ( e ) {
            e.preventDefault();
            const nextPage = nextBtn.getAttribute( 'href' );

            const loaded = nextBtn.parentElement.parentElement.querySelector( '#loaded' );
            const progress = nextBtn.parentElement.parentElement.querySelector( '#progress' ) as HTMLElement;

            const total = progress.getAttribute( 'data-total' );

            fetch( nextPage )
                .then( response => response.text() )
                .then( html => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString( html, 'text/html' );
                    const articles = doc.querySelectorAll( '#articles' + ' ' + blog );
                    const articlesContainer = document.createElement( 'div' );

                    articlesContainer.id = 'articles2';
                    articlesContainer.style.display = 'none';
                    articlesContainer.append( ...Array.from( articles ) );

                    document.querySelector( '#articles' ).append( articlesContainer );

                    const articleNew = document.querySelector( '#articles2' );
                    articleNew.replaceWith( ...Array.from( articleNew.childNodes ) );

                    const blogs = document.querySelector( '#articles' ).querySelectorAll( blog );
                    loaded.innerHTML = `${blogs.length}`;
                    progress.style.setProperty( '--w', `${blogs.length / parseInt( total ) * 100}%` );

                    fetch( nextPage )
                        .then( response => response.text() )
                        .then( html => {
                            const parser = new DOMParser();
                            const doc = parser.parseFromString( html, 'text/html' );
                            const nextBtnContainer = doc.querySelector( btn );

                            if ( nextBtnContainer ) {
                                nextBtn.closest( 'div' ).innerHTML = nextBtnContainer.outerHTML;
                                recall( btn, blog );
                            } else {
                                nextBtn.remove()
                            }
                        } );
                } );
        } );
    })( '#load-more', '.articles--item' )

    const form = document.querySelector( '.js-filter-form' ) as HTMLFormElement;

    if ( !form ) {
        return;
    }

    const ss = form.querySelector( '[name="ss"]' );
    const locations = form.querySelectorAll( '[name="location[]"]' );
    const types = form.querySelectorAll( '[name="type[]"]' );

    const jsFound = form.querySelector<HTMLElement>( '#js-found' );

    let timeout = null;

    ss?.addEventListener( 'input', fetchCount )
    locations.forEach(loc => loc.addEventListener( 'change', fetchCount ))
    types.forEach(type=> type.addEventListener( 'click', fetchCount ))

    function fetchCount(){
        const queryString = new URLSearchParams( new FormData( form ) as any ).toString();
        const url = `${form.action}?${queryString}`

        clearTimeout(timeout)
        timeout = setTimeout( function () {
            fetch( url )
                .then( response => response.text() )
                .then( html => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString( html, 'text/html' );
                    const found = doc.querySelector('#articles')?.getAttribute('data-found')

                    if ( jsFound && found !== null ) {
                        const count = parseInt(found);
                        const btn = jsFound.closest<HTMLButtonElement>('button');
                        const btnText = btn?.querySelector<HTMLElement>('.js-btn-text');
                        if (count === 0) {
                            if (btnText) btnText.innerHTML = btn.getAttribute('data-text-empty') || 'Geen resultaten';
                            jsFound.style.display = 'none';
                        } else {
                            if (btnText) btnText.innerHTML = btn.getAttribute('data-text-default') || 'Toon resultaten';
                            jsFound.style.display = '';
                            jsFound.innerHTML = `(${found})`;
                        }
                    }
                } );
        }, 1000 )
    }
}

export { loadMore as default };
